module.exports = __webpack_public_path__ + "media/components/images/create_document-f44db6d571512f6496eab52f80147d44.gif";